import { render } from "./Modal.vue?vue&type=template&id=bd396fa6&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=bd396fa6&scoped=true&lang=css"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd396fa6"]])

export default __exports__